module.exports = __webpack_public_path__ + "img/13.6f4ad325.jpg";